// extracted by mini-css-extract-plugin
export default {"modalWrapper":"filePreview_modalWrapper__Cf0Qy","modal":"filePreview_modal__tihW3","fadeInDown":"filePreview_fadeInDown__VP1Y0"};